// extracted by mini-css-extract-plugin
module.exports = {"Section2":"Section2_Section2__3_9cd","List":"Section2_List__37_B5","button":"Section2_button__3txmZ"};